/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZodiacCancer = createReactComponent("zodiac-cancer", "IconZodiacCancer", [
  ["path", { d: "M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M18 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M3 12a10 6.5 0 0 1 14 -6.5", key: "svg-2" }],
  ["path", { d: "M21 12a10 6.5 0 0 1 -14 6.5", key: "svg-3" }]
]);

export { IconZodiacCancer as default };
//# sourceMappingURL=IconZodiacCancer.js.map
